import { Injectable, Inject } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import {_} from '../../js/globals';
@Injectable({
    providedIn: 'root',
})
export class MySynchDataStore{

    private _currentActiveFarm: BehaviorSubject<object> = new BehaviorSubject({});
    public readonly currentActiveFarm: Observable<object> = this._currentActiveFarm.asObservable();

    private _currentActiveHerd: BehaviorSubject<object> = new BehaviorSubject({});
    public readonly currentActiveHerd: Observable<object> = this._currentActiveHerd.asObservable();

    private _currentUser: BehaviorSubject<object> = new BehaviorSubject({});
    public readonly currentUser: Observable<object> = this._currentUser.asObservable();

    private _currentPageType: BehaviorSubject<string> = new BehaviorSubject("");
    public readonly currentPageType: Observable<string> = this._currentPageType.asObservable();
    
    constructor(){
       
    }

    setActiveFarm(farm:any){
       /// this._currentActiveFarm = farm;
        this._currentActiveFarm.next(farm);
    }
    setActiveHerd(herd:any){
         this._currentActiveHerd.next(herd);
     }
    setCurrentPageType(pageType:string){
        this._currentPageType.next(pageType);
    }
    // should be used very seldomly, it is best to subscribe to the public variable in most cases.
    getCurrentPageType(){
       return this._currentPageType.getValue();
    }
     
    onUserChanged(user:any){
        this._currentUser.next(user);
    }
}